var map = {
	"./it/auth.json": [
		42783,
		2783
	],
	"./it/catalog.json": [
		31394,
		1394
	],
	"./it/changepassword.json": [
		98600,
		8600
	],
	"./it/common.json": [
		36040,
		6040
	],
	"./it/dashboard.json": [
		45361,
		5361
	],
	"./it/homepage.json": [
		39601,
		9601
	],
	"./it/instruments.json": [
		60967,
		967
	],
	"./it/learning-path-by-id.json": [
		96299,
		6299
	],
	"./it/learning-paths.json": [
		38626,
		8626
	],
	"./it/lesson.json": [
		93793,
		3793
	],
	"./it/masterclass-by-id.json": [
		3475,
		3475
	],
	"./it/onboarding.json": [
		81944,
		1944
	],
	"./it/order-confirmation.json": [
		15315,
		5315
	],
	"./it/pathdetail.json": [
		19551,
		9551
	],
	"./it/profile.json": [
		85036,
		5036
	],
	"./it/series-by-id.json": [
		96516,
		6516
	],
	"./it/studysession.json": [
		45434,
		5434
	],
	"./it/subscription.json": [
		26928,
		6928
	],
	"./it/teacher.json": [
		31807,
		1807
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 34839;
module.exports = webpackAsyncContext;